export default __webpack_public_path__ + "static/media/Cairo-Light.74621ea8.ttf";